import _ from "lodash";
import { SocialSettings } from "../../../../cores/me/interfaces/api/get-meSocialSettings";
import { SummaryPlatform, SyncedPlatforms } from "./summaryAnalyticsTypes";

export interface SummaryPlatformSources {
  socialSettings: SocialSettings | null;
  facebookSettings?: object | null;
  instagramSettings?: object | null;
  tiktokSettings?: object | null;
  linkedInBusinessSettings?: object | null;
}

export const getSummarySyncedPlatforms = (
  sources: SummaryPlatformSources
): SyncedPlatforms => ({
  facebook:
    Boolean(sources.socialSettings?.facebook) ||
    !_.isEmpty(sources.facebookSettings),
  instagram:
    Boolean(sources.socialSettings?.instagram) ||
    Boolean(sources.socialSettings?.instagramLogin) ||
    !_.isEmpty(sources.instagramSettings),
  tiktok: !_.isEmpty(sources.tiktokSettings),
  linkedinBusiness:
    Boolean(sources.socialSettings?.linkedInBusiness) ||
    !_.isEmpty(sources.linkedInBusinessSettings),
});

export const getSummarySyncedPlatformList = (
  sources: SummaryPlatformSources
): SummaryPlatform[] => {
  const platforms = getSummarySyncedPlatforms(sources);
  const list: SummaryPlatform[] = [];
  if (platforms.facebook) list.push("facebook");
  if (platforms.instagram) list.push("instagram");
  if (platforms.tiktok) list.push("tiktok");
  if (platforms.linkedinBusiness) list.push("linkedinBusiness");
  return list;
};

export const hasAnySummaryPlatform = (sources: SummaryPlatformSources) =>
  getSummarySyncedPlatformList(sources).length > 0;
